// Role → default landing page. Shared by AuthLayout's post-login redirect and
// PublicRoute/LoginPage so there is exactly one source of truth for "where
// does this role land after login" — previously LoginPage had its own copy
// racing against AuthLayout's hardcoded "/dashboard", which visibly
// double-navigated (most noticeably for accountant: dashboard, then a
// second hop to /finance/fee-collection half a second later).
export const ROLE_LANDING_ROUTE: Record<string, string> = {
  super_admin: '/dashboard',
  principal: '/dashboard',
  teacher: '/dashboard',
  accountant: '/finance/fee-collection',
  parent: '/dashboard',
  student: '/dashboard',
};
